import { useRef, useEffect, useState } from 'react';
import { Box, Text, Image, Button, Divider } from '@mantine/core';
import { useWindowScroll, useMediaQuery } from '@mantine/hooks';
import { primaryColor, ForeColorWhite, ForeColorBlack } from '../../lib/constants';

function Home() {
  const gcgcIcon = 'img/gcgcIcon.png';
  const banner = 'img/index/homeBackground-banner1.jpg';

  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);
  const [scroll, scrollTo] = useWindowScroll();
  const isMobile = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(node);

    if (node.getBoundingClientRect().top < window.innerHeight * 0.8) {
      setVisible(true);
      observer.disconnect();
    }

    return () => observer.disconnect();
  }, []);


  function getOffset(id) {
    return document.getElementById(id)?.offsetTop || 0;
  }

  function scrollToAboutUs() {
    const aboutUs = getOffset('aboutUs');
    scrollTo({ y: aboutUs - 150 });
  }

  return (
    <Box
      id="home"
      w="100%"
      h="100dvh"
      bg={ForeColorWhite}
      style={{ overflow: 'visible', position: 'relative' }}
    >
      <Box
        id="bannerBox"
        w="100%"
        h="100%"
        style={{ position: 'relative', zIndex: 1 }}
      >
        {/* Background Image */}
        <Box
          style={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            backgroundImage: `url(${banner})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: isMobile ? 'scroll' : 'fixed',
            zIndex: 0,
          }}
        >
          {/* Gradient Overlay */}
          <Box
            style={{
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(to top, #363636 0%, transparent 10%)',
              zIndex: 1,
              pointerEvents: 'none',
            }}
          />
        </Box>

        {/* Foreground Content */}
        <Box
          ref={sectionRef}
          className={visible ? 'fade-text delay-0' : 'text-hidden'}
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            height: '100%',
            width: isMobile ? '100%' : '40%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            textAlign: 'center',
            color: '#ffffff',
            zIndex: 2,
            padding: isMobile ? '20px' : '40px',
          }}
        >
          <Text
            fz={isMobile ? 50 : 64}
            mt={isMobile?  "-100%":0}
            style={{
              fontWeight: 600,
              color: ForeColorBlack,
              marginBottom: 10,
              lineHeight: 1.2,
            }}
          >
            <em>"We Simply <br /> Do It Better"</em>
          </Text>

          <Image
            src={gcgcIcon}
            alt="Global Comfort Group Corp"
            style={{
              objectFit: 'contain',
              height: isMobile ? '80px' : '150px',
              marginBottom: 12,
            }}
          />

          <Divider
            size="sm"
            color="blue"
            my={30}
            style={{ width: isMobile ? '40%' : '30%' }}
          />

          <Button
            variant="outline"
            color="blue"
            h={50}
            w={200}
            size={isMobile ? 'md' : 'lg'}
            onClick={scrollToAboutUs}
          >
            LEARN MORE
          </Button>
        </Box>
      </Box>

      {/* Animation CSS */}
      <style>
        {`
          .fade-text {
            opacity: 1;
            transform: translateY(0);
            transition: opacity 0.8s ease-out, transform 0.8s ease-out;
          }

          .text-hidden {
            opacity: 0;
            transform: translateY(30px);
          }

          .delay-0 {
            transition-delay: 0.2s;
          }
        `}
      </style>
    </Box>
  );
}

export default Home;
